"use client";

import { c as _c } from "react/compiler-runtime";
import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { useMemo } from "react";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";
import { apiErrorMessage } from "@/lib/api-error";
import { AppConfigProvider } from "@/lib/config";
import { ProviderMarksProvider } from "@llmgateway/shared/components";
import type { AppConfig } from "@/lib/config-server";
import type { ReactNode } from "react";
interface ProvidersProps {
  children: ReactNode;
  config: AppConfig;
}
export function Providers(t0) {
  const $ = _c(10);
  const {
    children,
    config
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new QueryClient({
      mutationCache: new MutationCache({
        onError: _temp
      }),
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          staleTime: 300000,
          retry: false
        }
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  if ($[1] !== children || $[2] !== config.apiUrl) {
    t2 = <QueryClientProvider client={queryClient}><ProviderMarksProvider apiUrl={config.apiUrl}>{children}</ProviderMarksProvider></QueryClientProvider>;
    $[1] = children;
    $[2] = config.apiUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Toaster />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} storageKey="theme">{t2}{t3}</ThemeProvider>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== config || $[8] !== t4) {
    t5 = <AppConfigProvider config={config}>{t4}</AppConfigProvider>;
    $[7] = config;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp(error, _variables, _context, mutation) {
  if (mutation.options.onError || mutation.meta?.inlineError) {
    return;
  }
  toast.error(apiErrorMessage(error, mutation.meta?.errorMessage ?? "Request failed"));
}